import React from 'react';
import { MobileMenuSidebarProps } from './mobile-menu-sidebar.props';
import { SidebarOrganism } from '../sidebar';
import { LogoMolecule } from '../../molecules';
import { CloseIconMolecule } from '../../molecules/close-icon';
import Link from 'next/link';

export const MobileMenuSidebarOrganism = (props: MobileMenuSidebarProps) => {
  return (
    <SidebarOrganism
      closeSidebar={props.closeMenu}
      opened={props.opened}
      showCloseIcon={false}
    >
      <div data-cy="mobile-menu-sidebar-organism">
        <div className="flex flex-row justify-between items-center border-b py-5 border-waldo-sands">
          <CloseIconMolecule close={props.closeMenu} />
          <LogoMolecule className="w-32" />
        </div>
        <nav
          className={`flex flex-column items-center text-center w-full h-full overflow-x-hidden`}
        >
          <ul className="list-none p-0 flex flex-col justify-between items-center text-left relative w-full mt-5">
            {props.mobileMenuLinks.map((link) => (
              <li
                key={`${link.href}${link.label}`}
                className={`w-full text-center py-5 whitespace-nowrap font-medium ${link.className}`}
              >
                <Link href={link.href}>
                  <a className="no-underline">{link.label}</a>
                </Link>
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </SidebarOrganism>
  );
};
